module.exports = __webpack_public_path__ + "42a0fc8bd71522f12ced3d3cb648e734.svg";